import { useState } from "react";
import { Blog } from "../../models/blog";
import NewsModal from "./NewsModal";

export default function NewsEntry({
  news,
  index,
}: {
  news: Blog;
  index: number;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={"flex flex-col lg:flex-row cursor-pointer gap-4"}
        onClick={() => setIsModalOpen(true)}
      >
        <div className="h-48 w-full lg:w-80 flex-shrink-0">
          <img
            className={`w-full h-full object-cover cursor-pointer rounded-2xl`}
            src={news.image}
            alt={news.title}
            onClick={() => setIsModalOpen(true)}
          />
        </div>
        <div className="flex flex-col gap-2">
          <div
            className={
              "mt-3 text-md md:text-xl lg:text-xl 2xl:text-2xl font-bold break-words"
            }
          >
            {news.title}
          </div>
          <div className="text-sm md:text-base lg:text-sm flex flex-row gap-2">
            {news.date && <strong>Wann?</strong>}
            {news.date}
          </div>
          <div className="text-sm md:text-base lg:text-sm flex flex-row gap-2 ">
            <p className="line-clamp-3 2xl:line-clamp-5 text-ellipsis">
              {news.excerpt}
            </p>
          </div>
        </div>
      </div>

      <NewsModal
        news={news}
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
      />
    </>
  );
}
